import * as tslib_1 from "tslib";
import { QueryBuilder } from '../QueryBuilder/QueryBuilder';
var MembersRequestBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(MembersRequestBuilder, _super);
    function MembersRequestBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * add filter with members ids
     * {
     *    "query": {
     *      "filter": {
     *        "id": {
     *          "$in" : ["0f0e8afc-fb2e-4e35-9645-db34ac8b129b", "c1d92c76-371f-43c4-9070-a5a76ad9e84d"]
     *        }
     *      }
     *    }
     *  }
     * @return {QueryBuilder<wrapper.wix.social.groups.api.v1.QueryGroupMembersRequest>}
     */
    MembersRequestBuilder.prototype.filterWithIds = function ($in) {
        return this.addFilter({ id: { $in: $in } });
    };
    return MembersRequestBuilder;
}(QueryBuilder));
export { MembersRequestBuilder };
//# sourceMappingURL=MembersRequestBuilder.js.map